export default {"src":"/_next/static/media/it.c843f03c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};